exports = module.exports = require("../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".upload_area[data-v-b75693e4] {\n  display: flex;\n  gap: 20px;\n  flex-wrap: wrap;\n}\n@media (max-width: 768px) {\n.upload_area[data-v-b75693e4] {\n    align-items: center;\n}\n.upload_area .upload_block[data-v-b75693e4], .upload_area output[data-v-b75693e4], .upload_area select[data-v-b75693e4], .upload_area .file_block[data-v-b75693e4] {\n    width: 100%;\n}\n}", ""]);

// exports
